<template>
  <div class="menu-chunk">
    <div class="menu">
      <div
        class="menu-chlidren"
        v-for="(item, index) in menuList"
        :key="index"
        @mouseenter="switchMoreNav(index)"
        @mouseleave="switchMoreNav(null)"
      >
        <div
          class="menu-title"
          @click="chilkMenu(item)"
          :class="{active: parseInt($route.query.selectMenuId) === item.id}"
        >
          <div
            class="menu-title-center"
            :style="{'border-right': index !== menuList.length -1 ? '1px solid #E6E6E6' : '0px'}"
          >{{item.name}}</div>
        </div>
        <img
          src="../../assets/triangle-menu.png"
          v-if="selectMoreIndex === index && item.category.length !== 0"
          class="menu-triangle"
        />
        <div class="menu-more" v-if="selectMoreIndex === index">
          <div
            class="menu-more-chlidren"
            v-for="(row, index) in item.category"
            :key="index"
            @mouseenter="switchChildrenNav(row.id)"
            @mouseleave="switchChildrenNav(null)"
            :class="{active: parseInt($route.query.selectMoreId) === row.id}"
            :style="{'border-top': index !== 0 ? '1px solid #E6E6E6' : '0px'}"
            @click="clickMore(row, item.id)"
          >
            <div>{{row.name}}</div>
            <img
              src="../../assets/arrow-white.png"
              class="menu-more-arrow"
              v-if="$route.query.selectMoreId === row.id && row.category.length !== 0"
            />
            <img
              src="../../assets/grey-arrow.png"
              class="menu-more-arrow"
              v-else-if="selectChildId !== row.id && row.category.length !== 0"
            />
            <img
              src="../../assets/arrow.png"
              class="menu-more-arrow"
              v-else-if="selectChildId === row.id && row.category.length !== 0"
            />
            <div class="menu-three" v-if="selectChildId === row.id">
              <div class="menu-three-children">
                <div
                  class="menu-three-name"
                  v-for="(line, index) in row.category"
                  :key="line.name"
                  :class="{active: parseInt($route.query.selectThreeId) === line.id}"
                  :style="{'border-top': index !== 0 ? '1px solid #E6E6E6' : '0px'}"
                  @click.stop="clickThree(line, row.id, item.id)"
                >{{line.name}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuList: [],
      selectMoreIndex: 0,
      selectChildId: null
    };
  },
  created() {
    this.getMenuList();
  },
  methods: {
    getMenuList() {
      this.$http.get("/open/cms/category/get-all-category").then(res => {
        this.menuList = res.data.data;
      });
    },
    switchMoreNav(index) {
      this.selectMoreIndex = index;
    },
    switchChildrenNav(id) {
      this.selectChildId = id;
    },
    eidtBreadcrumbList(id) {
      this.$store.commit("eidtBreadcrumb", id);
    },
    chilkMenu(item) {
      if (item.name === "网站首页") {
        this.$router.push({ name: "home", query: { selectMenuId: item.id } });
      } else {
        this.eidtBreadcrumbList(item.id);
        this.$router.push({
          name: "articleList",
          query: { selectMenuId: item.id, type: item.categoryType }
        });
      }
    },
    clickMore(row, itemId) {
      this.eidtBreadcrumbList(row.id);
      this.$router.push({
        name: "articleList",
        query: {
          selectMenuId: itemId,
          type: row.categoryType,
          selectMoreId: row.id,
          selectThreeId: ""
        }
      });
    },
    clickThree(line, rowId, itemId) {
      this.eidtBreadcrumbList(line.id);
      this.$router.push({
        name: "articleList",
        query: {
          selectThreeId: line.id,
          selectMenuId: itemId,
          type: line.categoryType,
          selectMoreId: rowId
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.menu {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  font-size: 16px;
  color: #313233;
  &-chunk {
    position: relative;
    width: 1200px;
    height: 60px;
    margin: -10px auto 16px auto;
    background: white;
  }
  &-chlidren {
    display: flex;
    flex-direction: column;
    height: fit-content;
    width: 171.5px;
  }
  &-title {
    margin: 4px 5px;
    width: 162px;
    height: 52px;
    cursor: pointer;
    &:hover {
      color: #f08a3e;
    }
    &-center {
      width: 172px;
      height: 32px;
      line-height: 32px;
      margin: 10px 0 0 -5px;
      text-align: center;
    }
  }
  &-triangle {
    width: 16px;
    height: 8px;
    margin: 5px 0 0 25px;
    transform: rotate(180deg);
  }
  &-more {
    font-size: 16px;
    z-index: 1000;
    width: 180px;
    background-color: white;
    box-shadow: 0px 0px 10px 0px rgba(37, 34, 32, 0.2);
    &-chlidren {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      padding: 0 16px;
      cursor: pointer;
      &:hover {
        color: #f08a3e;
      }
    }
    &-arrow {
      position: absolute;
      top: 14px;
      right: 16px;
      height: 14px;
      width: 8px;
    }
  }
  &-three {
    position: absolute;
    width: 180px;
    left: 180px;
    top: 0%;
    display: flex;
    align-items: center;
    font-size: 14px;
    &-children {
      background-color: white;
      width: 180px;
      box-shadow: 0px 0px 10px 0px rgba(37, 34, 32, 0.2);
    }
    &-name {
      height: 40px;
      width: 100%;
      line-height: 40px;
      padding: 0 16px;
      color: #313233;
      cursor: pointer;
      &:hover {
        color: #f08a3e;
      }
    }
  }
}
.active {
  color: white;
  border-radius: 2px;
  background: linear-gradient(
    135deg,
    rgba(254, 179, 57, 1) 0%,
    rgba(242, 139, 56, 1) 100%
  );
  &:hover {
    color: white;
  }
}
</style>
